import { atom } from "recoil";

const userState = atom({
  key: "userState",
  default: null,
});

export default userState;
